/** Имя микрофронтенда рекламных баннеров */
export const AD_BANNER_MF_NAME = 'ad-banner-frontend';

/** Глобальный флаг конфига, включающий интеграцию микрофронтенда рекламных баннеров */
export const AD_BANNER_MF_ENABLED_KEY = 'MarTech.AdBannerMicrofrontend.Enabled';

/** Ключ настройки конфига, под которым лежит сырой манифест микрофронтенда */
export const AD_BANNER_MF_MANIFEST_SETTING_KEY = 'adBannerMicrofrontendManifest';
